angular.module('festzelt-os.modules.contacts', [
    'festzelt-os.components'
]);

require('./routes');

require('./controllers/store/duplicates-extended-listview');
require('./components/al-contact-selector/component');
require('./components/contact-consumptions/component');

require('./factories/contact-factory');
require('./store/contacts');
require('./store/contact-duplicates');



// WEBPACK FOOTER //
// ./src/app/modules/contacts/module.js